<!--
  新的视频转换器权益页面
 -->
<template>
  <div class="video-interests">
    <div
      v-for="right in viewModel.rightList"
      :key="right.title"
    >
      <h3 class="video-interests-title">
        {{ right.title }}
      </h3>
      <ul class="video-interests-list clearfix">
        <li
          v-for="item in right.list"
          :key="item.title"
          @click="handleClickIconItem(item)"
          class="video-interests-item"
        >
          <div
            :class="
              `sprite-video-icon-${item.className}  ${item.noRight ? item.className + '-grey' : ''}`
            "
            class="sprite-video-icon item-pic"
          />
          <p v-html="item.title" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, computed } from '@vue/composition-api'
import { useReflectiveInjector } from '@zhfe/vue2-di-plugin'

import { UserService } from '@/services/user.service.ts'
import { CustomerService } from '@/services/customer.service'
import client from '@/client/'

export default defineComponent({
  name: 'NewVideoInterests',

  setup (props, context) {
    const injector = useReflectiveInjector()
    const user = injector.get(UserService)
    const customer = injector.get(CustomerService)

    const viewModel = reactive({
      rightList: [
        {
          title: 'PDF编辑',
          list: [
            { className: 'item1', title: 'PDF插入文字' },
            { className: 'item2', title: 'PDF插入图片' },
            { className: 'item3', title: 'PDF擦除' },
            { className: 'item4', title: '提取图片文字' },
            { className: 'item5', title: 'PDF加密/解密' },
            { className: 'item6', title: '数字安全签名' },
            { className: 'item7', title: '水印/去水印' },
            { className: 'item8', title: '扫描件去背景' },
            { className: 'item9', title: 'PDF批量打印' },
            { className: 'item10', title: '发票打印' },
            { className: 'item11', title: 'VIP客服', vipMethod: openVipService, report: 25 },
          ],
        },
        {
          title: 'PDF转换',
          list: [
            { className: 'item13', title: '不限大小次数', report: 251, method: openConvert, convert: '1' },
            { className: 'item14', title: 'PDF转Word', report: 252, method: openConvert, convert: '1' },
            { className: 'item15', title: 'Word转PDF', report: 253, method: openConvert, convert: '21' },
            { className: 'item16', title: 'CAD转换', report: 254, method: openConvert, convert: '41' },
            { className: 'item17', title: '扫描件转换', report: 255 },
            { className: 'item18', title: '图片PDF互转', report: 256, method: openConvert, convert: '24' },
            { className: 'item19', title: 'PDF无损压缩', report: 257, method: openConvert, convert: '38' },
            { className: 'item20', title: '纯图PDF', report: 258, method: openConvert, convert: '6' },
            { className: 'item21', title: '图片转格式', report: 259, method: openConvert, convert: '55' },
            { className: 'item22', title: '图片压缩', report: 260, method: openConvert, convert: '53' },
          ]
        },
        {
          title: '页面编辑',
          list: [
            { className: 'item25', title: 'PDF页码' },
            { className: 'item26', title: '页眉页脚' },
            { className: 'item27', title: 'PDF合并' },
            { className: 'item28', title: 'PDF拆分' },
            { className: 'item29', title: '增删页面' },
            { className: 'item30', title: '页面裁剪' },
            { className: 'item31', title: '页面分割' },
            { className: 'item32', title: '页面排序' },
          ],
        },
        {
          title: '图片编辑',
          list: [
            { className: 'item37', title: '图片裁剪' },
            { className: 'item38', title: '抠图/去背景' },
            { className: 'item39', title: '消除笔' },
            { className: 'item40', title: '无损放大' },
            { className: 'item41', title: '图片水印' },
            { className: 'item42', title: '魔法擦除' }],
        },
        {
          title: '视频转换',
          list: [
            { className: 'item43', title: '视频格式转换' },
            { className: 'item44', title: '视频分割' },
            { className: 'item45', title: '视频水印' },
            { className: 'item46', title: '视频压缩' },
            { className: 'item47', title: '视频合并' },
            { className: 'item48', title: '视频转GIF' },
            { className: 'item49', title: '视频美化' },
          ],
        },
        {
          title: '特色功能',
          list: [
            { className: 'item55', title: '数据恢复' },
            { className: 'item56', title: '文档修复' },
            { className: 'item57', title: '文档对比' },
            { className: 'item58', title: '视频转换' },
            { className: 'item59', title: '截图对比' },
          ],
        },
        {
          title: '极光PDF金山联合会员，享有以下特权(需下载金山毒霸)',
          list: [
            { className: 'item61', title: '数据恢复' },
            { className: 'item62', title: '文件夹加密' },
            { className: 'item63', title: '文件粉碎' },
            { className: 'item64', title: 'C盘瘦身专家' },
            { className: 'item65', title: '浏览器主页修复' },
            { className: 'item66', title: '文档修复' },
            { className: 'item67', title: '文档卫士' },
          ],
        },
      ],
      loginStatus: user.loginStatus, // 是否登录
    })

    // 是否vip
    const isVip = computed(
      () => user.isMember || user.isPdfMember || user.isPdfLifeMember || user.isDiamondMember || user.isVideoMember || user.isVideoLifeMember
    )

    // 图片点击时处理函数
    const handleClickIconItem = (item) => {
      item.method && item.report && client.home.REPORT.reportHomeOperate({
        main_click: item.report,
        user_login: viewModel.loginStatus
      })

      // vipMethod属性 & isVip，则调起vip客服
      item.vipMethod && isVip.value && item.vipMethod()

      // PDF转换的方法
      item.method && item.method(item)
    }

    /** 打开vip客服 */
    async function openVipService () {
      const url = await customer.getContactCustomerServiceUrl('vip-center')
      url && window.open(url)
    }

    /** 打开PDF转换器 */
    function openConvert (data) {
      client_openKisProcess({
        name: 'pdfconverter.exe',
        arg: {
          vipfrom: '6001',
          from: '3',
          type: data.convert
        },
      })
    }

    function client_openKisProcess (params) {
      client.common.API.client_openKisProcess(params)
    }

    return {
      viewModel,

      handleClickIconItem
    }
  },

})
</script>

<style lang="scss" scoped>
@import '@/assets/css/sprite-video-icon.scss';

.video-interests{
  margin-top: 20px;
}
.video-interests-title {
  color: #575757;
  font-size: 20px;
  margin-bottom: 10px;
  padding: 0 24px;
  font-weight: normal;
}
.video-interests-list {
  padding-left: 9px;
}
.video-interests-item {
  background: #fffbe9;
  width: 92px;
  height: 120px;
  position: relative;
  box-sizing: border-box;
  border: 1px solid #fdd63c;
  color: #000005;
  font-size: 14px;
  float: left;
  margin-left: 17px;
  text-align: center;
  line-height: 1.2;
  border-radius: 4px;
  margin-bottom: 22px;
  cursor: pointer;
  &:hover {
    background: #ffebde !important;
    border-color: #de461e !important;
  }
  .item-pic {
    width: 64px;
    height: 64px;
    margin: 12px auto 8px;
    background: url(~@/assets/images/privileges-new.png) no-repeat;
  }

  @for $i from 0 to 12 {
    @for $j from 0 to 6 {
      .sprite-video-icon-item#{$i * 6 + $j + 1} {
        background-position: -64px * $j -64px * $i;
      }
    }
  }
}
</style>
